import ShipmentPoints from '@/views/deliveries/ShipmentPoints.vue'
import Limits from '@/views/limits/Limits.vue'
import Taxes from '@/views/taxes/Taxes.vue'
import PriceConfigs from '@/views/weights/PriceConfigs.vue'
import Stats from '@/views/stats/Stats.vue'

export const Routes = {
  shipmentPoints: 'shipmentPoints',
  deliveries: 'deliveries',
  deliveryEdit: 'deliveryEdit',
  deliveryCreate: 'deliveryCreate',
  limits: 'limits',
  limitEdit: 'limitEdit',
  limitCreate: 'limitCreate',
  taxes: 'taxes',
  taxEdit: 'taxEdit',
  taxCreate: 'taxCreate',
  priceConfigs: 'priceConfigs',
  priceConfigCreate: 'priceConfigCreate',
  priceConfigEdit: 'priceConfigEdit',
  stats: 'stats',
}

export default [
  {
    path: '',
    name: Routes.shipmentPoints,
    component: ShipmentPoints,
    props: true,
    children: [
      {
        path: '/price-configs/',
        name: Routes.priceConfigs,
        props: true,
        component: PriceConfigs,
        children: [
          {
            path: 'create',
            name: Routes.priceConfigCreate,
            component: () =>
              import(
                /* webpackChunkName: "price_config_create" */ '../views/weights/PriceConfigCreate.vue'
              ),
          },
          {
            path: ':priceConfigId',
            name: Routes.priceConfigEdit,
            component: () =>
              import(
                /* webpackChunkName: "price_config_edit" */ '../views/weights/PriceConfigEdit.vue'
              ),
          },
        ],
      },
      {
        path: '/limits/',
        name: Routes.limits,
        props: true,
        component: Limits,
        children: [
          {
            path: 'create',
            name: Routes.limitCreate,
            component: () =>
              import(
                /* webpackChunkName: "limit_create" */ '../views/limits/LimitCreate.vue'
              ),
          },
          {
            path: ':limitId',
            name: Routes.limitEdit,
            component: () =>
              import(
                /* webpackChunkName: "limit_edit" */ '../views/limits/LimitEdit.vue'
              ),
          },
        ],
      },
      {
        path: '/deliveries/:shipmentPointId/',
        name: Routes.deliveries,
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "deliveries" */ '../views/deliveries/Deliveries.vue'
          ),
        children: [
          {
            path: 'create',
            name: Routes.deliveryCreate,
            component: () =>
              import(
                /* webpackChunkName: "delivery_create" */ '../views/deliveries/DeliveryCreate.vue'
              ),
          },
          {
            path: ':deliveryId',
            name: Routes.deliveryEdit,
            component: () =>
              import(
                /* webpackChunkName: "delivery_edit" */ '../views/deliveries/DeliveryEdit.vue'
              ),
          },
        ],
      },
      {
        path: '/stats/',
        name: Routes.stats,
        component: Stats,
      },
      {
        path: '/taxes/',
        name: Routes.taxes,
        props: true,
        component: Taxes,
        children: [
          {
            path: 'create',
            name: Routes.taxCreate,
            component: () =>
              import(
                /* webpackChunkName: "tax_create" */ '../views/taxes/TaxCreate.vue'
              ),
          },
          {
            path: ':taxId',
            name: Routes.taxEdit,
            component: () =>
              import(
                /* webpackChunkName: "tax_edit" */ '../views/taxes/TaxEdit.vue'
              ),
          },
        ],
      },
    ],
  },
]
